import React from 'react';
import { Container } from 'react-bootstrap';
import { MembersTable } from './table/MembersTable';

export default function AllMembers() {
    return (
        <Container style={{marginBottom: '40px'}}>
            <MembersTable />
        </Container>
    )
}